import { tooltip } from "../partials/bootstrap-tooltip";


function favoris() {
    $('.favoris').off('click').on('click', function (e) {
        e.preventDefault();
        $.ajax({
            url: $(this).attr('href'),
        }).done(function (data) {
            $('#favoris-'+data.id).toggleClass('active');
            $('#favoris-count').html(data.count)
        });
        return false;
    });
}
favoris();


function comparateur() {
    $('.comparateur').off('click').on('click', function (e) {
        e.preventDefault();
        $.ajax({
            url: $(this).attr('href'),
        }).done(function (data) {
            $('.comparateur').removeClass('active');
            data.ids.forEach(function(id){
                if ($('#comparateur-' + id).length) {
                    $('#comparateur-' + id).addClass('active');
                }
            });
            if (data.message) {
                $('.link-comparateur [data-toggle="dropdown"]').data('title', data.message).attr('data-original-title', data.message).tooltip('show').tooltip('toggle');
            }
            $('#comparateur-count').html(data.count)
            $('#comparateur-dropdown').html(data.liste)
            comparateur();
        });
        return false;
    });
}
comparateur();

function updateListe() {
    $.ajax({
        url: $('#recherche').data('url'),
        data: $('#recherche').serialize()
    }).done(function (data) {
        $('#vehicule_list').html(data.liste).data('page', data.currentPage).data('lastpage', data.lastPage);
        $('#vehicule_filtres').html(data.filtres);

        favoris();
        comparateur();
        tooltip();
        eventFiltres();
        eventNewsletterButton();

    });
}


$('#recherche select, #recherche input').on('change', function () {
    updateListe()
});


function eventFiltres() {
    $('#vehicule_filtres button').on('click', function () {

        var modeles = $(this).parent().parent().data('modeleIds').toString().split('-').filter(e => e != $(this).data('modeleId'));

        $('#filter-marque').val(modeles);

        updateListe();
    });
}
eventFiltres()



// Initialisation page recherche
if ($('#recherche').length) {
    updateListe();
}


function eventNewsletterButton() {
    var $newsletterButton = $('#newsletter-button');
    if ($newsletterButton.length) {
        $newsletterButton.click(function () {
            console.log($(this).data('url') + '?email=' + $('#newsletter-email').val());
            window.location.href = $(this).data('url') + '?email=' + $('#newsletter-email').val();
            return false;
        });
    }
}
eventNewsletterButton()



